import React from 'react'
import { theme, useCurrentDoc, ComponentsProvider } from 'docz'
import posthog from 'posthog-js'
import { PostHogProvider } from 'posthog-js/react'

import * as typography from '@entur/typography'

/* eslint-disable react/display-name */

import * as icons from '@entur/icons'

import { BannerAlertBox } from '@entur/alert'

import { ExpandablePanel } from '@entur/expand'

import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    HeaderCell,
    DataCell,
} from '@entur/table'

import { CurrentSectionProvider } from '~/components/CurrentSectionProvider/CurrentSectionProvider'
import CardBoxGrid from '~/components/CardBoxGrid/CardBoxGrid'
import Changelog from '~/components/Changes/Changelog'
import GithubReleasesChangelog from '~/components/Changes/GithubReleasesChangelog'
import RestTester from '~/components/RestTester'
import Swagger from '~/components/Swagger'
import DownloadLink from '~/components/DownloadLink/DownloadLink'
import Page from '~/components/Page/Page'
import FrontPageNavBar from '~/components/FrontPageNavBar/FrontPageNavBar'
import FrontPageFooter from '~/components/FrontPageFooter/FrontPageFooter'
import NavBar from '~/components/NavBar/NavBar'
import NewPortalAlert from '~/components/NewPortalAlert/NewPortalAlert'

import './index.scss'

const map = {
    h1: typography.Heading1,
    h2: typography.Heading2,
    h3: typography.Heading3,
    h4: typography.Heading4,
    h5: typography.Heading5,
    h6: typography.Heading6,
    p: typography.Paragraph,
    a: typography.Link,
    pre: typography.PreformattedText,
    strong: typography.StrongText,
    b: typography.StrongText,
    inlineCode: typography.CodeText,
    ul: typography.UnorderedList,
    li: typography.ListItem,
    ol: typography.NumberedList,
    page: Page,
    CardBoxGrid,
    Changelog,
    GithubReleasesChangelog,
    RestTester,
    Swagger,
    DownloadLink,
    BannerAlertBox,
    ExpandablePanel,
    table: (props: HTMLTableElement) => <Table {...props} width="fluid" />,
    thead: TableHead,
    tbody: TableBody,
    tr: TableRow,
    th: (props: HTMLTableHeaderCellElement) => (
        <HeaderCell {...props} align="left" />
    ),
    td: DataCell,
    ...icons,
}

const App: React.FC = ({ children }: { children?: React.ReactNode }) => {
    const currentDoc = useCurrentDoc()
    if (typeof window !== 'undefined') {
        window.addEventListener('UC_CONSENT', function (event) {
            const customEvent = event as CustomEvent
            // 'eOSEhoTfkUqK9U' is the id for posthog service in Usercentrics
            if (customEvent.detail.services.eOSEhoTfkUqK9U.consent.given) {
                posthog.opt_in_capturing()
            } else {
                posthog.opt_out_capturing()
            }
        })
        posthog.init('phc_pDlGj2cCojWTLzG5QZSjyvE5Fx0pZrcsUCXRjTvfofl', {
            api_host: 'https://eu.i.posthog.com',
            opt_out_capturing_by_default: true,
        })
    }
    return (
        <ComponentsProvider components={map}>
            <PostHogProvider client={posthog}>
                <NewPortalAlert />
                {currentDoc.frontpage ? (
                    <>
                        <FrontPageNavBar />
                        <main>{children}</main>
                        <FrontPageFooter />
                    </>
                ) : (
                    <CurrentSectionProvider>
                        <NavBar />
                        <Page>{children}</Page>
                    </CurrentSectionProvider>
                )}
                <script src="https://lj5mck2ctgl0.statuspage.io/embed/script.js"></script>
            </PostHogProvider>
        </ComponentsProvider>
    )
}

export default theme({})(App)
